import React, { useRef, useState } from "react";
import DropzoneComponent from "react-dropzone-component";
import "dropzone/dist/min/dropzone.min.css";

// MIME type validation helper
const isValidMimeTypes = (types) => {
  if (typeof types !== "string") return false;
  return types
    .split(",")
    .every(type => /^[a-z]+\/[a-z0-9\-\+\.]+$/i.test(type.trim()));
};

const SingleFileUpload = ({
  onFileUpload,
  fileError,
  setFileError, 
  acceptedFilesType = "application/pdf,image/jpeg,image/jpg,image/png"
}) => {
  const dropzoneRef = useRef(null);
  const [fileUploaded, setFileUploaded] = useState(false);

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

  const ALLOWED_TYPES = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp"
  ];

  const validatedAcceptedTypes = isValidMimeTypes(acceptedFilesType)
    ? acceptedFilesType
    : "application/pdf,image/jpeg,image/jpg,image/png";

  const componentConfig = {
    postUrl: "no-url",
  };

  const djsConfig = {
    maxFiles: 1,
    acceptedFiles: validatedAcceptedTypes,
    autoProcessQueue: false,
    addRemoveLinks: true,
    dictDefaultMessage: "Drag & drop a file here or click to select",
    dictRemoveFile: "Remove",
  };

  const eventHandlers = {
    addedfile: (file) => {
      if (file.size > MAX_FILE_SIZE) {
        setFileError("Maximum file size allowed: 2MB");
        dropzoneRef.current.dropzone.removeFile(file);
        setFileUploaded(false);
        return;
      }else if (!ALLOWED_TYPES.includes(file.type)) {
        setFileError("Only PDF, PNG, JPG, JPEG, WEBP files are allowed.");
        setFileUploaded(false);
        return;
      } 
      else {
        setFileError("");
      }

      if (dropzoneRef.current.dropzone.files.length > 1) {
        dropzoneRef.current.dropzone.removeFile(
          dropzoneRef.current.dropzone.files[0]
        );
      }

      setFileUploaded(true);
      onFileUpload(file);
    },
    removedfile: () => {
      setFileUploaded(false);
      onFileUpload(null);
    },
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div className="custom-dropzone-wrapper" style={{ width: "100%" }}>
        <DropzoneComponent
          ref={dropzoneRef}
          config={componentConfig}
          eventHandlers={eventHandlers}
          djsConfig={djsConfig}
        />
      </div>
      {fileUploaded && (
        <div
          style={{
            position: "absolute",
            top: 15,
            left: 160,
            background: "#4caf50",
            color: "#fff",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: "bold",
            zIndex: 10,
          }}
        >
          ✓
        </div>
      )}
      {fileError&& <p className="text-danger left_15">{fileError}</p>}
    </div>
  );
};

export default SingleFileUpload;
